import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonDataTable from '../../../components/CommonDataTable';
import { getCartoonList } from '../../../services/carton/carton';
const rawColumns = [
    { field: 'PkgID', headerName: 'Pkg ID', width: 200 },
    { field: 'pkgType', headerName: 'Pkg Type', width: 130 },
    { field: 'PkgSize', headerName: 'Pkg Size', width: 160 },
    { field: 'dimensions', headerName: 'Dimensions', width: 160 },
    { field: 'VolCapacity', headerName: 'Vol Capacity (cm3)', width: 150 },
    { field: 'WeightCapacity', headerName: 'Weight Capacity', width: 150 },
    { field: 'Exclusions', headerName: 'Exclusions', width: 180 }

];
export default function PackagingMasterList({ onCreateClick, refreshKey, onView, onEdit }) {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    //   ----------------- Update table when catons prop changes -----------------
    const loadList = useCallback(async (page, pageSize) => {
        try {
            const cartons = await getCartoonList(page, pageSize);
            if (cartons?.data.length) {
                const formattedcatons = cartons.data.map(carton => ({
                    id: carton._id,
                    PkgID: carton.pkgId,
                    pkgType: carton.pkgType,
                    PkgSize: carton.pkgSize,
                    dimensions: carton.dimensions,
                    VolCapacity: carton.volCapacity,
                    WeightCapacity: carton.weightCapacity,
                    Exclusions: carton.exclusions,
                    __original: carton
                }));

                setTableRows(formattedcatons);
                setTotalCount(cartons?.pagination.totalRecords);
            }

            else {
                setTableRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error(err);
        }
    }, []);


    useEffect(() => {
        loadList(page, pageSize);
    }, [refreshKey, page, pageSize, loadList]);

    // ----------------- Menu handling -----------------
    const handleOpenMenu = (e, row) => {
        e.stopPropagation();
        setMenuAnchorEl(e.currentTarget);
        setMenuRow(row);
    };
    const handleCloseMenu = () => {
        setMenuAnchorEl(null);
        setMenuRow(null);
    };

    const actionColumn = {
        field: "__actions",
        headerName: "",
        width: 100,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
            <IconButton
                size="small"
                onClick={(e) => handleOpenMenu(e, params.row)}
                aria-label="row actions"
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
        ),
    };

    const allPossibleColumns = useMemo(() => [actionColumn, ...rawColumns], []);
    const initialVisible = useMemo(
        () => allPossibleColumns.map((c) => c.field),
        [allPossibleColumns]
    );

    return (
        <>
            <CommonDataTable
                allPossibleColumns={allPossibleColumns}
                initialVisible={initialVisible}
                initialRows={tableRows}
                height={520}
                rowsPerPageOptions={[10, 25, 50, 100]}
                exportImportPath="InventoryLedger"
                forItems
                showCreateButton={true}
                createButtonText="Create New"
                createButtonIcon="bi-plus-lg"
                onCreateClick={onCreateClick}
                createButtonVariant="contained"
                createButtonColor="primary"
                page={page}
                pageSize={pageSize}
                rowCount={totalCount}
                onPageChange={(newPage) => setPage(newPage)}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
                onDataRefresh={async ({ filters = [], page: p = 0, pageSize: ps = pageSize } = {}) => {

                    console.log("ASN ....................... received onDataRefresh:", { filters, page: p, pageSize: ps });

                }}
            />

            <Menu open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={handleCloseMenu}>
                <MenuItem onClick={() => onView(menuRow.__original)}>
                    <i className="bi bi-eye me-2" /> View
                </MenuItem>
                <MenuItem onClick={() => onEdit(menuRow.__original)}>
                    <i className="bi bi-pencil me-2" /> Edit
                </MenuItem>
            </Menu>
        </>
    );
}
